<template>
  <div class="columnlistBox">
    <div v-if="columnlist.length>0">
      <div v-for="item in columnlist" :key="item.COLUMN_ID" class="column_li">
        <lisTemplate4 :list="item" />
      </div>
    </div>
    <div v-else style="margin-bottom: 20px;text-align: center;font-size: 20px;color: #a19d9e;font-weight: 600;background-color: #ffffff;height: 150px;line-height: 150px;">
      暂无数据
    </div>
  </div>
</template>
<script>
import lisTemplate4 from '@/components/centerlist_albumn/listTemplate4/index.vue'
export default {
  components: { lisTemplate4 },
  props: ['columnlist', 'isvdo'],
  data() {
    return {
    }
  }

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .columnlistBox:after{
      content: "";
      display: block;
      clear: both;
      height: 0px;
    }
    .columnlistBox{
        margin-top: 20px;
        .column_li{
          background-color: #fff;
            width: 410px;
            height: 230px;
            display: inline-block;
            float: left;
            margin-right: 60px;
            margin-bottom: 20px;
            position: relative;
          transition: 0.3s;
          &:hover{
            transform: translate(0,-3px);
          }
            .vdoIMG{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                border: 3px solid rgba(249,245,246,.5);
                position: absolute;
                top: 67px;
                left: 114px;
            }
            .vdoIMG::after{
                content: '';
                display: block;
                position: absolute;
                top: 13px;
                left: 15px;
                width: 0;
                height: 0;
                border-top: 12px solid transparent;
                border-bottom:  12px solid transparent;
                border-left:20px solid rgba(247,247,247,.5);
            }
        }
      .column_li:nth-child(2n){
        margin-right: 0;
      }
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px){
    .columnlistBox{
      margin-top: 0;
      .column_li,.lastcolumn_li{
        height: auto;
        width: auto;
        margin: 10px 20px;
      }
    }
  }
</style>

